export const profileContactPageConstraint = (
  translateKey1: string,
  translateKey2: string,
  translateKey3: string,
  translateKey4: string
): { [key: string]: any } => {
  return {
    phoneNumber: {
      presence: {
        allowEmpty: false,
        message: translateKey4,
      },
      format: {
        pattern: '^[5].*',
        flags: 'i',
        message: translateKey1,
      },
      length: {
        minimum: 9,
        maximum: 9,
        message: translateKey2,
      },
      numericality: {
        onlyInteger: true,
        message: translateKey3,
      },
    },
  };
};
